import { useStore } from "@nanostores/react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { cartDetails } from "../../../pages/[locale]/cart/stores/details.store";
import {
  applyDiscount,
  discount,
} from "../../../pages/[locale]/cart/stores/discount.store";

type UseDiscountFormProps = {
  defaultOpen: boolean;
};

type FieldValues = {
  code: string;
};

export function useDiscountForm({ defaultOpen }: UseDiscountFormProps) {
  const { register, handleSubmit, reset } = useForm<FieldValues>();
  const $cartDetails = useStore(cartDetails);
  const $discount = useStore(discount);

  const [isDiscountFormOpen, setIsDiscountFormOpen] = useState(defaultOpen);

  const isDiscountFormDisabled =
    !isDiscountFormOpen ||
    $discount.status === "loading" ||
    $cartDetails.status === "loading";

  function toggleDiscountFormOpen() {
    setIsDiscountFormOpen((v) => !v);
  }

  const onSubmit = handleSubmit(async ({ code }: FieldValues) => {
    await applyDiscount(code);

    // Manually clear the input on success
    if (discount.get().status === "success") {
      reset();
    }
  });

  return {
    register,
    onSubmit,
    isDiscountFormOpen,
    toggleDiscountFormOpen,
    isDiscountFormDisabled,
    error: $discount.error,
  };
}
